var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-guidelines",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd",
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography",
    transform: "translate(-880.000000, -479.000000)",
    fill: "#212121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/warning-warning-(snackbars,-modals)",
    transform: "translate(880.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-path1",
    d: "M14.9998791,2 C14.083749,2 13.2461504,2.46370916 12.7738095,3.2700661 L0.354685144,24.5137969 C-0.117774964,25.3224708 -0.118681581,26.3111858 0.354685144,27.1190607 C0.814193643,27.9027935 1.64140367,28.4022747 2.55945263,28.4 L27.4403058,28.4 C28.3583957,28.4034557 29.1856398,27.9026546 29.6450733,27.1190607 C30.1187638,26.3111163 30.1178538,25.3225055 29.6450733,24.5137969 L17.2259486,3.2700661 C16.7536077,2.46370916 15.9160091,2 14.9998791,2 L14.9998791,2 Z M14.9998791,4.08421103 C15.1683974,4.08421103 15.3976319,4.21285548 15.4685253,4.33388214 L27.88765,25.5776129 C27.958499,25.6988098 27.9586933,25.9340825 27.88765,26.0552446 C27.8023495,26.2007226 27.6091071,26.3161879 27.4403058,26.3157721 L2.55945263,26.3157721 C2.39061729,26.3161184 2.19732033,26.2005836 2.11210852,26.0552446 C2.0410822,25.934013 2.04127988,25.6988446 2.11210852,25.5776129 L14.5312329,4.33388214 C14.6021262,4.21285548 14.8313675,4.08421103 14.9998791,4.08421103 L14.9998791,4.08421103 Z M14.9998791,10.6842126 C14.4351859,10.6842126 13.9773782,11.150798 13.9773782,11.7263181 L13.9773782,20.0631379 C13.9773782,20.6386928 14.4351859,21.1052434 14.9998791,21.1052434 C15.5646063,21.1052434 16.0223799,20.6386928 16.0223799,20.0631379 L16.0223799,11.7263181 C16.0223799,11.150798 15.5646063,10.6842126 14.9998791,10.6842126 Z M14.9998791,21.7999805 C14.2469265,21.7999805 13.6365446,22.4220827 13.6365446,23.1894545 C13.6365446,23.956861 14.2469265,24.5789285 14.9998791,24.5789285 C15.7528248,24.5789285 16.3632135,23.956861 16.3632135,23.1894545 C16.3632135,22.4220827 15.7528248,21.7999805 14.9998791,21.7999805 L14.9998791,21.7999805 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.057b28381946d9086e8f47a28a7ab841.svg";
export { ForwardRef as ReactComponent };